import BenchlingConfig from 'BenchlingConfig';
import {makeReactContext} from 'lib/makeReactContext';

export interface ProjectsSidepanelContextInterface {
  // If set, then we will not show the section tabs on the ProjectSidepanel listing component
  hideSectionTabsWhenExpanded: boolean;
  rootCrumbName: string;
}

/**
 * Our root Crumb Name can change depending on if we have the ENABLE_TEMPLATE_COLLECTIONS_IN_WORKSPACE set to
 * true. Instead of having to check that in several places, we instead create a React Context here that
 * contains our root crumb name.
 */
export const ProjectsSidepanelContext = makeReactContext<ProjectsSidepanelContextInterface>(
  () => ({
    rootCrumbName: BenchlingConfig.ENABLE_TEMPLATE_COLLECTIONS_IN_WORKSPACE
      ? 'Projects & Templates'
      : 'Projects',
    hideSectionTabsWhenExpanded: !BenchlingConfig.ENABLE_TEMPLATE_COLLECTIONS_IN_WORKSPACE,
  }),
  'ProjectsSidepanelContext'
);
